import {Injectable} from '@angular/core';
import 'rxjs/add/operator/map';
import * as firebase from 'firebase';
import {BehaviorSubject, Observable} from "rxjs";
import {AngularFireAuth} from "angularfire2/auth";
import {FirebaseProvider} from "./firebaseProvider";
import {Doctor} from "../../models/doctor/doctor.interface";
import {forkJoin} from "rxjs/observable/forkJoin";
import {of} from "rxjs/observable/of";
import {catchError} from "rxjs/operators";
import {Patient} from "../../models/patient/patient.interface";

@Injectable()
export class FirebaseAuthProvider {
    private authState: Observable<firebase.User>;
    private currentUserSubject = new BehaviorSubject<firebase.User>(null);
    private currentUser: firebase.User = null;
    private selectedPatient: Patient = null;
    private currentDoctor: Doctor = null;
    private currentAdmin = false;

    constructor(
        private afAuth: AngularFireAuth,
        private firebaseProvider: FirebaseProvider
    ) {
        this.authState = this.afAuth.authState;
        this.listenForAuthStatusEvents();
    }

    getCurrentUserSubject() {
        return this.currentUserSubject;
    }

    /**
     * Returns true, if the current user is successfully authenticated,
     * false otherwise
     */
    isAuthenticated(): boolean {
        //console.debug("CHECK AUTH: ", this.currentUser);
        if (this.currentUser !== null) {
            //console.debug("CHECK AUTH UID: ", this.currentUser.uid);
        }

        return this.currentUser !== null;
    }

    /**
     * Returns true, if the current user is a doctor,
     * false otherwise
     */
    isDoctor(): boolean {
        return this.currentDoctor !== null;
    }

    /**
     * Returns true, if the current user is an admin,
     * false otherwise
     */
    isAdmin(): boolean {
        return this.currentAdmin;
    }

    /**
     * Returns the current authenticated user
     */
    getCurrentUser(): firebase.User {
        return this.currentUser;
    }

    /**
     * Returns the currently selected patient (from doctor page)
     */
    getSelectedPatient(): Patient {
        return this.selectedPatient;
    }

    setSelectedPatient(patient: Patient) {
        this.selectedPatient = patient;
    }

    /**
     * Logout user
     */
    logout(): firebase.Promise<any> {
        return this.afAuth.auth.signOut();
    }

    /**
     * Listen for firebase auth status changes and update internal infos accordingly
     */
    private listenForAuthStatusEvents() {
        this.authState.subscribe(user => {
                console.debug("Auth state has changed: ", user !== null ? user.uid : null);

                if (user) {
                    // get all relevant infos in parallel, afterwards switch user
                    let doctor$ = this.firebaseProvider.getDoctorForUID(user.uid).pipe(catchError(error => {
                        return of(null);
                    }));
                    let admin$ = this.firebaseProvider.getAllAdminUsers();

                    forkJoin(doctor$, admin$).subscribe(([doctor, adminUsers]) => {
                        this.currentDoctor = doctor;
                        this.currentAdmin = adminUsers.indexOf(user.uid) >= 0;

                        //console.debug("User is doctor", this.currentDoctor !== null);
                        //console.debug("User is admin", this.currentAdmin);

                        this.currentUser = user;
                        this.currentUserSubject.next(user);
                    }, error => {
                        console.debug("Error", error);
                    });

                } else {
                    this.currentUser = null;
                    this.selectedPatient = null;
                    this.currentAdmin = false;
                    this.currentDoctor = null;

                    this.currentUserSubject.next(null);
                }
            },
            err => {
                console.warn("Could not get auth state", err);
            });
    }
}



// WEBPACK FOOTER //
// ./src/providers/firebase/firebaseAuthProvider.ts